import axios from "axios";
import store from "../redux/store";

import { getCookie, isNull } from "../shared/helpers";
import { Auth } from "../config/aws-exports";
import { responsesAreSame } from "workbox-broadcast-update";
import ExportTypography from "antd/lib/typography/Typography";

const profile = JSON.parse(localStorage.getItem("userProfile"));

const BackendApiBaseUrl = process.env.REACT_APP_API_URL; //REACT_APP_MY_URL
const BackendHubspotAPI = process.env.REACT_APP_SKILLGIGSSUBSCRIBER_URL;

const fetchDataUrl = `${BackendApiBaseUrl}/`; //sample
const sendDataUrl = `${BackendApiBaseUrl}/`; //sample
// const getMatchesUrl = `${BackendApiBaseUrl}/empgigs/getmygigmatches`;
const updateProfileUrl = `${BackendApiBaseUrl}/profile`; // need to append /profileId later
// const sendEmailVerifyStatusURL = `${BackendApiBaseUrl}/profile/send-verification-link`;
const sendEmailVerifyStatusURL = `https://4olovalef3.execute-api.us-east-2.amazonaws.com/production/profile/send-verification-link`;
const uploadFileUrl = `${BackendApiBaseUrl}/upload`; // need to append /profileId later
const uploadDPUrl = `${BackendApiBaseUrl}/upload`; // need to append /profileId later
const fetchDocUrl = `${BackendApiBaseUrl}/credentialing/userdoc`;
const uploadDocUrl = `${BackendApiBaseUrl}/document/upload`;
const fetchProfileDetails = `${BackendApiBaseUrl}/profile/me`;
const fetchExistUserUrl = `${BackendApiBaseUrl}/auth/checkUser`;
const getSkillsUrl = `${BackendApiBaseUrl}/skill/getSkills`;
const skillListingUrl = `${BackendApiBaseUrl}/skill/listing`;
const fetchProfileExperience = `${BackendApiBaseUrl}/profile/experienceLevels`;
const fetchDeclineReasonsURL = `${BackendApiBaseUrl}/bids/declinedstatus`;
// const createBidUrl = `${BackendApiBaseUrl}/bids/create`;
const createBidUrl = `${BackendApiBaseUrl}/bids/create`;
const createmultiBidUrl = `${BackendApiBaseUrl}/bids/createmulti`;

const updateBidUrl = `${BackendApiBaseUrl}/bids/update`;
// const updateBidUrl = `http://192.168.18.101:5000/production/bids/update`;

const fetchMessagesUrl = `${BackendApiBaseUrl}/message`;
const fetchConversationCountUrl = `${BackendApiBaseUrl}/empprofile/messages/conversationsCounts`;
const checkGapURL =`${BackendApiBaseUrl}/empprofile/contracts/findgap`;

const updateProposalUrl = `${BackendApiBaseUrl}/proposal/recievedBidsByEmp/update`;
//*******************************************Ratings***********************************************

const postRatingUrl = `${BackendApiBaseUrl}/empprofile/ratings/create`;
const putRatingUrl = `${BackendApiBaseUrl}/empprofile/ratings/update`;
const deleteRatingsUrl = `${BackendApiBaseUrl}/empprofile/rating/delete`;

//*******************************************Ratings***********************************************//

//messages new designs*********************************************************************
const getInboxUrl = `${BackendApiBaseUrl}/empprofile/messages/all`;
const getChatHistoryUrl = `${BackendApiBaseUrl}/empprofile/messages/get`;
const sendMessageUrl = `${BackendApiBaseUrl}/message/send`;
const offerAttachment = `${BackendApiBaseUrl}/interview/offer/make`;
const editOfferUrl = `${BackendApiBaseUrl}/interview/offer/update`;
const getRatingUrl = `${BackendApiBaseUrl}/empprofile/ratings/get`;
const messagesCountUrl = `${BackendApiBaseUrl}/empprofile/messages/counts`;

/******************************************Messages**************************************/

const getFiltersUrl = `${BackendApiBaseUrl}/guest/getfilters`;
const getMyGigFiltersUrl = `${BackendApiBaseUrl}/guest/allmygigscounts`;
const getCompanyProfileDetailsUrl = `${BackendApiBaseUrl}/empprofile/getcompanyprofile`;
// const getCompanyProfileDetailsUrl =  `http://localhost:3000/staging/empprofile/getcompanyprofile`;

const getCompanyGigsUrl = `${BackendApiBaseUrl}/empprofile/getjobcounts`;

const getPersonalDetailsLocationUrl = `${BackendApiBaseUrl}/skill/locations`;
// const getPersonalDetailsLocationUrl = `${BackendApiBaseUrl}/skill/locations`;
const sendAttachments = `${BackendApiBaseUrl}/message/attachment`;
const createInterviewUrl = `${BackendApiBaseUrl}/interview/create`;
let updateInterviewUrl = `${BackendApiBaseUrl}/interview/empupdate`;

//Interviews

// const getAllInterviewsUrl = `${BackendApiBaseUrl}/interview/getallinterviews`;
const getAllInterviewsUrl = `${BackendApiBaseUrl}/interview/getallinterviews`;

//CAndidate Profile
const profileDetailsUrl = `${BackendApiBaseUrl}/guest/get`;
const profileDetailReviews = `${BackendApiBaseUrl}/guest/getreviews`;
const postNotesApiUrl = `${BackendApiBaseUrl}/skill/note`;
const getNotesApiUrl = `${BackendApiBaseUrl}/skill/note`;
const updateNotesApiUrl = `${BackendApiBaseUrl}/skill/note`;
const getRemindersUrl = `${BackendApiBaseUrl}/skill/DashboardNotes`;
const getCoversationIdURL = `${BackendApiBaseUrl}/guest/getbidconversation`;

//Personal Details
const updatePersonalDetailsUrl = `${BackendApiBaseUrl}/empprofile/updatedetails`;

//Search
const getSearchSuggestionUrl = `${BackendApiBaseUrl}/search`;

//Company Profile
const getCompanyDetailsDropdownUrl = `${BackendApiBaseUrl}/empprofile/companydetails`;
const postCompanyDetailsUrl = `${BackendApiBaseUrl}/empprofile/updatedetails`;

const fetchAllGigsUrl = `${BackendApiBaseUrl}/bids/searchGigs`;
const AddMessageToFavouriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/add`;
const fetchFollowersUrl = `${BackendApiBaseUrl}/empprofile/getfollowers`;
const updateEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/update`;
const eidtEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/updatepic`;

const deleteEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/delete`;
const getEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/get`;
const createGigUrl = `${BackendApiBaseUrl}/empgigs`;
const getSearchSkillsUrl = `${BackendApiBaseUrl}/skill/getSkills`;
const updateGigUrl = `${BackendApiBaseUrl}/empgigs/update`;

//SKillListings
const userSkillListing = `${BackendApiBaseUrl}/skill/listing`;
const SkillListingTotalCount = `${BackendApiBaseUrl}/guest/filterscount`;
const SkillListingCount = `${BackendApiBaseUrl}/guest/allcounts`;
//Jobs/Gigs
const getJobListingUrl = `${BackendApiBaseUrl}/empgigs/getmygigs`;
const getJobCountsUrl = `${BackendApiBaseUrl}/empgigs/getmygigcounts/$`;
const getCandidateCountsUrl = `${BackendApiBaseUrl}/guest/totalcountsprivate`;
const getRecentJobListingUrl = `${BackendApiBaseUrl}/empgigs/getrecent`;

const getJobListingDraftUrl = `${BackendApiBaseUrl}/empgigs/getmygigsdraft`;
const checkUserName = `${BackendApiBaseUrl}/auth/check-username`;
const getHRMSUrl = `${BackendApiBaseUrl}/empprofile/getHRMs`;

const getMyMatchesUrl = `${BackendApiBaseUrl}/empgigs/getmygigmatches`;
const perUserSkillListing = `${BackendApiBaseUrl}/empprofile/getskilllisting`;
const deleteJobUrl = `${BackendApiBaseUrl}/empgigs/delete`;
const getJobDetailUrl = `${BackendApiBaseUrl}/empgigs`;
const getJobBidDetailUrl = `${BackendApiBaseUrl}/empgigs/GetGigDetail`;

// recent search url
const recentSearchUrl = `${BackendApiBaseUrl}/guest/getRecents`;
const trendingJobsUrl = `${BackendApiBaseUrl}/bids/trendings`;
const clearRecentSearchUrl = `${BackendApiBaseUrl}/guest/clearRecents`;

//Post A Job
const fetchjobTemplateUrl = `${BackendApiBaseUrl}/empgigs/templates`;

const JobTitleUrl = `${BackendApiBaseUrl}/empgigs/get/gigtitle`;
const addUpdateUserDeviceDeatilsURL = `${BackendApiBaseUrl}/profile/user-device`;
//employerdashboard
const fetchdashboardUrl = `${BackendApiBaseUrl}/empprofile/dashboard`;
// const fetchdashboardInterviewUrl = `http://localhost:3000/production/empprofile/dashboardInterviews`;
const fetchdashboardInterviewUrl = `${BackendApiBaseUrl}/empprofile/dashboardInterviews`;
// const fetchdashboardMatchesUrl = `http://localhost:3000/production/empprofile/dashboardMatches`;
const fetchdashboardMatchesUrl = `${BackendApiBaseUrl}/empprofile/dashboardMatches`;
//Favorites
// const fetchFavoritesUrl = `${BackendApiBaseUrl}/empprofile/favorites/get?type=web&page=1&perPage=`;
const fetchFavoritesUrl = `${BackendApiBaseUrl}/empprofile/favorites/get`;
//Post a Favorite
const postFavoriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/add `;
//Delete a Favorite
const deleteFavoriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/remove`;

const getCulturePhotosUrl = `${BackendApiBaseUrl}/empprofile/albums/get`;
const removeMessageFromFavouriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/remove`;
const fetchViewsUrl = `${BackendApiBaseUrl}/empprofile/getviews`;
//Skill Matches
const getMatchedSkillsUrl = `${BackendApiBaseUrl}/empgigs/match/get`;
const addToMatchUrl = `${BackendApiBaseUrl}/empgigs/match/add`;
const batchMatchUrl = `${BackendApiBaseUrl}/empgigs/multi-matches/add`;
const removeFromMatchUrl = `${BackendApiBaseUrl}/empgigs/match/delete`;
const findMyMatches = `${BackendApiBaseUrl}/empgigs/matchesRecommendations/get`;
const matchesCount = `${BackendApiBaseUrl}/empgigs/GetGigMatchesCounts`;
const matchesPagination = `${BackendApiBaseUrl}/empgigs/matches/pagination`;

//Timesheet
const getTimeSheetListUrl = `${BackendApiBaseUrl}/getall`;
const getTimesheetUrl = `${BackendApiBaseUrl}/getTimesheet`;
const approveTimesheetUrl = `${BackendApiBaseUrl}/empprofile/payments/create`;
const getGraphDetailsUrl = `${BackendApiBaseUrl}/getgraph`;
const rejectTimesheetUrl = `${BackendApiBaseUrl}/timesheet/corrections`;

//3d Resume
const getResume3dUrl = `${BackendApiBaseUrl}/emp3dresume/get`;
// const viewIncrementUrl = `${BackendApiBaseUrl}/emp3dresume/getviews`;
// const viewFollowersUrl = `${BackendApiBaseUrl}/emp3dresume/getfollowers`;
const viewFollowersUrl = `${BackendApiBaseUrl}/emp3dresume/getfollowers`;
const viewIncrementUrl = `${BackendApiBaseUrl}/emp3dresume/getviews`;

const followUrl = `${BackendApiBaseUrl}/empprofile/follow/add`;
const unFollowUrl = `${BackendApiBaseUrl}/empprofile/follow/remove`;

//Notifications
// const notificationUrl = `${BackendApiBaseUrl}/empprofile/notifications/get`;
const notificationUrl = `${BackendApiBaseUrl}/empprofile/notifications/get`;
// const notificationUrl = `http://192.168.18.101:4000/production/empprofile/notifications/get`;
const readNotificationUrl = `${BackendApiBaseUrl}/empprofile/notification/update`;

//My team
const getPendingTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/pending`;
const getActiveTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/active`;
const getInActiveTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/inactive`;
const addTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/add`;
const updateTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/update`;
const getAllPaymentsUrl = `${BackendApiBaseUrl}/empprofile/payments/getAll`;
const reactivateTeamMemberUrl = `${BackendApiBaseUrl}/empprofile/teammembers/reactivate`;
const activateTeamMemberUrl = `${BackendApiBaseUrl}/empprofile/teammembers/update`;
// Manage Candidates --> get candidates/egetcandidates/get

const getCandidatesUrl = `${BackendApiBaseUrl}/empprofile/getcandidates/get`;
const candidatesUrl = `${BackendApiBaseUrl}/empprofile/getcandidates`;
// const getCandidateCountUrl = `${BackendApiBaseUrl}/empprofile/getCandidatesCounts`;
const getCandidateCountUrl = `${BackendApiBaseUrl}/empprofile/getCandidatesCountsNew`;
//My Matches
const getMatchesUrl = `${BackendApiBaseUrl}/empgigs/getmygigmatches`;
const getABSurl = `${BackendApiBaseUrl}/empprofile/ABS/get`;
const getFollowersApi = `${BackendApiBaseUrl}/emp3dresume/getfollowers`;
const removePrivateTalent = `${BackendApiBaseUrl}/empprofile/removePrivateTalent`;
// const getFollowersApi= `${BackendApiBaseUrl}/emp3dresume/getfollowers`
const HubspotAPI = `${BackendHubspotAPI}/subscribe/dispatch`;

const getHRMDetailsAPI = `${BackendApiBaseUrl}/empprofile/getHRMsDetails`;
const getABSDetailsAPI = `${BackendApiBaseUrl}/empprofile/ABSFacilities`;

const UserTrackingURL = `${BackendApiBaseUrl}/user-tracking`;
const checkEmailExistURL = `${BackendApiBaseUrl}/profile/emailExist`
const profileAddCandidateURL = `${BackendApiBaseUrl}/profile/addCandidate`

const invitedTalentURL = `${BackendApiBaseUrl}/empprofile/invitedCandidates`
const searchInvitedTalentURL = `${BackendApiBaseUrl}/api/invitedCandidates`
const numberCheckURL = `${BackendApiBaseUrl}/check-number`;

let token = null;
let headers = null;
let ImpersonationId = null;

const fetchHeader = (token, ImpersonationId) => {
  let email = localStorage.getItem("email");
  if (ImpersonationId) {
    headers = {
      "Content-Type": "application/json",
      Authorization: token,
      impersonationid: ImpersonationId,
      "Access-Control-Allow-Origin": "*",
      // params: "61264b4304ff062ef86cec27",
    };
  } else {
    headers = {
      "Content-Type": "application/json",
      Authorization: token,
      "Access-Control-Allow-Origin": "*",
      // email: email,
    };
  }

  return headers;
};

export const checkUserNameUnique = async (payload) => {
  const response = await axios.post(`${checkUserName}`, payload);

  return response;
};

export const fetchToken = async () => {
  token = await store.getState().authReducer.user.authToken;
  ImpersonationId = await store.getState().authReducer.impersonationId;

  return fetchHeader(token, ImpersonationId);
};

// fetch Profile Experience
export const fetchProfileExperienceAPI = async () => {
  const response = await axios.get(fetchProfileExperience);
  return response;
};

export const getFollowersV2 = async (payload) => {
  const headers = await fetchToken();
  const response = await axios.put(`${getFollowersApi}/${payload.id}`, "", {
    headers,
  });
  return response;
};

//city
// export const searchLocationSuggestionsApi = async (value) => {
//   let locFilterType;
//   if(value.payload.obj.type == 'city'){
//    locFilterType='city'
//   }
//   else if(value.payload.obj.type == 'region'){
//    locFilterType='region'
//   }
//   else if(value.payload.obj.type == 'state'){
//    locFilterType='state'
//   }
//   const fetchLocationAPI = `http://192.168.18.49:4000/development/skill/locationsuggestion?${locFilterType}=${value.payload.obj.value}`;
//    const response = await axios.get(fetchLocationAPI);
//   return response;
// };

// get regions

export const searchRegionSuggestionsApi = async (value) => {
  var fetchLocationAPI;
  if (value.payload == undefined) {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getregions`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getregions?region=${value.payload.obj.value}`;
  }

  const response = await axios.get(fetchLocationAPI);
  return response;
};
//Dynamic Locations
export const searchLocationSuggestionsApi = async (value) => {
  var fetchLocationAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined) {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getSkillListingLocation`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getSkillListingLocation?${value.payload.value}`;
  }
  const response = await axios.put(fetchLocationAPI, value.payload.body, {
    headers,
  });
  return response;
};

export const searchCompaniesAndIndustriesApi = async (value) => {
  var fetchCompanyAndIndustryAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined) {
    fetchCompanyAndIndustryAPI = `${BackendApiBaseUrl}/guest/getSkillListingIndustryCompany`;
  } else {
    fetchCompanyAndIndustryAPI = `${BackendApiBaseUrl}/guest/getSkillListingIndustryCompany?${value.payload.value}`;
  }
  const response = await axios.put(
    fetchCompanyAndIndustryAPI,
    value.payload.body,
    {
      headers,
    }
  );
  return response;
};

export const searchSkillsApi = async (value) => {
  var fetchSkillsAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined) {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getSkillListingSkills`;
  } else {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getSkillListingSkills?${value.payload.value}`;
  }
  const response = await axios.put(fetchSkillsAPI, value.payload.body, {
    headers,
  });
  return response;
};

// get countries

export const searchStateSuggestionsApi = async (value) => {
  var fetchLocationAPI;
  if (value.payload == undefined) {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getcountries`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getcountries?country=${value.payload.obj.value}`;
  }
  const response = await axios.get(fetchLocationAPI);
  return response;
};
// Fetch Location API
export const fetchSearchLocationAPI = async (value) => {
  const fetchLocationAPI = `${BackendApiBaseUrl}/skill/locations?location=${value.payload}`;
  const response = await axios.get(fetchLocationAPI);
  return response;
};

// Fetch User Skill Listings
export const fetchUserSkillListingAPI = async () => {
  const headers = await fetchToken();
  const response = await axios.get(skillListingUrl, { headers });
  return response;
};

export const fetchDeclinedReasonsBidsAPI = async (payload) => {
  const headers = await fetchToken();
  const response = await axios.get(
    `${fetchDeclineReasonsURL}/${payload}`,
    // `${fetchReceivedBidsDetailUrl}/declinedstatus/${payload}`,
    {
      headers,
    }
  );
  return response;
};

export const postRatingAPI = async (params) => {
  const headers = await fetchToken();
  const response = await axios.post(postRatingUrl, params, { headers });
  return response;
};

export const putRatingAPI = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${putRatingUrl}/${params.Ratings_id}`,
    params,
    { headers }
  );
  return response;
};

export const deleteRatingAPI = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${deleteRatingsUrl}/${params.Ratings_id}`,
    params,
    { headers }
  );
  return response;
};

// Fetch Discipline API
export const fetchSearchDisciplineAPI = async (value) => {
  const fetchDisciplineAPI = `${BackendApiBaseUrl}/skill/discipline?discipline=${value.payload}`;
  const response = await axios.get(fetchDisciplineAPI);
  return response;
};

export const fetchSearchSkillAPI = async (value) => {
  const categoryId = value.payload.profCode === "HC" ? 3 : 1;
  const fetchDisciplineAPI = `${BackendApiBaseUrl}/skill/discipline?discipline=${value.payload.val}&categoryId=${categoryId}`;
  const response = await axios.get(fetchDisciplineAPI);
  return response;
};


// LinkedIN User
const fetchLinkedInToken = `${BackendApiBaseUrl}/auth/linkedInSignin`;
export const approveLinkedInUserAPI = async (token) => {
  const response = await axios.post(
    fetchLinkedInToken,
    {
      code: token,
      redirectURL: `${process.env.REACT_APP_MY_URL}/linkcheck`,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const fetchDocsList = async () => {
  const headers = await fetchToken();
  const response = await axios.get(fetchDocUrl, { headers });
  return response;
};

export const getHRMSApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(getHRMSUrl, { headers });
  return response;
};

export const uploadFileApi = async (request, userToken) => {
  const headers = await fetchToken();
  const { file } = request.params;
  const contentType = file.type;
  request.params["contentType"] = contentType;
  const response = await axios.post(uploadFileUrl, request.params, {
    headers,
  });
  const { uploadURL, Key } = response.data;
  const uploadResponse = await axios.put(uploadURL, file);
  if (uploadResponse.status == 200) {
    return { data: { status: "success", payload: Key } };
  } else {
    return {
      data: {
        status: "error",
        error: { message: "File upload failed", code: uploadResponse.status },
      },
    };
  }
};

export const uploadDocApi = async (request) => {
  const response = await axios.post(uploadDocUrl, request.params, {
    headers: { "Content-Type": "multipart/form-data", Authorization: token },
  });
  return response;
};

export const removeDocApi = async (request) => {
  await fetchToken();
  const response = await axios.delete(`${fetchDocUrl}/${request.params}`, {
    headers: { Authorization: token },
  });
  return response;
};

export const fetchProfileURL = async (params) => {
  if (params?.impersonationId) {
    headers = fetchHeader(params.token, params.impersonationId);
  } else {
    headers = await fetchToken();
  }
  const response = await axios.get(fetchProfileDetails, {
    // headers: { Authorization: token },
    headers,
  });
  return response;
};

export const updateProfileApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.put(`${updateProfileUrl}`, request.params, {
    headers,
  });
  return response;
};

export const uploadProfilePicApi = async ({ params }) => {
  await fetchToken();
  const response = await axios.put(`${uploadDPUrl}`, params, {
    headers: { "Content-Type": "multipart/form-data", Authorization: token },
  });
  return response;
};

export const fetchSkillsApi = async (request) => {
  const categoryId = 3;

  const response = await axios.get(
    `${getSkillsUrl}?skillName=${request.params}&SkillCategoryId=${categoryId}`
  );
  return response;
};

export const createSkillListingApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.post(`${skillListingUrl}`, request.params, {
    headers,
  });
  return response;
};

export const updateSkillListingApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${skillListingUrl}/${request.params.id}`,
    request.params,
    {
      headers,
    }
  );
  return response;
};

export const fetchDataApi = async (params) => {
  return await axios.get(fetchDataUrl);
};

export const sendDataApi = async (params) => {
  const data = JSON.stringify(params);
  return await axios.post(sendDataUrl, data, { headers });
};

export const checkUserApi = async (request) => {
  const response = await axios.post(
    fetchExistUserUrl,
    { email: request.params },
    { headers }
  );
  return response;
};

export const viewIncrementApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${viewIncrementUrl}/${request.payload}`,
    request.payload,
    { headers }
  );
  return response;
};

export const fetchChatHistoryApi = async (id) => {
  const headers = await fetchToken();
  return await axios.get(`${getChatHistoryUrl}/${id}`, { headers });
  // const response = fetch(`${getChatHistoryUrl}/${id}`, { mode: 'cors', cache: 'no-cache', headers: { 'Access-Control-Allow-Origin': '*', "Content-Type": "application/json", 'Authorization': token } })
  // return response
};

export const fetchConversationCountAPI = async (request) => {
  const headers = await fetchToken();
  if (
    request?.HRMid == null &&
    request?.bidType == null &&
    request?.bidStatus == null
  ) {
    return await axios.get(`${fetchConversationCountUrl}`, { headers });
  } else {
    // t t t
    if (
      request?.bidType !== null &&
      request?.bidStatus != "null" &&
      request.bidStatus != null &&
      request?.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidStatus=${request?.bidStatus}&bidType=${request.bidType}&HRMid=${request.HRMid}`,
        { headers }
      );
    }
    // t f f
    if (
      request?.bidType !== null &&
      (request?.bidStatus == "null" || request.bidStatus == null) &&
      request?.HRMid == null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidType=${request.bidType}`,
        { headers }
      );
    }

    // f t t
    if (
      request?.bidType == null &&
      request?.bidStatus != "null" &&
      request.bidStatus != null &&
      request?.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidStatus=${request?.bidStatus}&HRMid=${request.HRMid}`,
        { headers }
      );
    }

    // f f t
    if (
      request?.bidType == null &&
      (request.bidStatus == null || request.bidStatus == "null") &&
      request.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?HRMid=${request.HRMid}`,
        { headers }
      );
    }

    // t f t
    if (
      request.bidType != null &&
      (request?.bidStatus == "null" || request?.bidStatus == null) &&
      request?.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidType=${request?.bidType}&HRMid=${request.HRMid}`,
        { headers }
      );
    }
    // f t f
    if (
      request.bidType == null &&
      request?.bidStatus != "null" &&
      request?.bidStatus != null &&
      request?.HRMid == null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidStatus=${request?.bidStatus}`,
        { headers }
      );
    }
    // f f f
    if (
      request.bidType == null &&
      (request?.bidStatus == "null" || request?.bidStatus == null) &&
      request?.HRMid == null
    ) {
      return await axios.get(`${fetchConversationCountUrl}`, { headers });
    }
  }
};

export const fetchMessagesAPI = async (messageType, limit, skip) => {
  const headers = await fetchToken();
  return await axios.get(
    `${fetchMessagesUrl}/${messageType}/${limit}/${skip}`,
    { headers }
  );
};

export const getInboxMessagesAPi = async (payload) => {
  const headers = await fetchToken();
  // favourites
  if (payload?.hrmId && payload?.hrmId != 0)
    return await axios.get(
      `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
        payload.bidStatus
      }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
        payload.perPage ?? 5
      }&HRMid=${payload?.hrmId}`,
      { headers }
    );
  if (payload?.jobOrderId && payload?.hrmId && payload?.hrmId != 0)
    return await axios.get(
      `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
        payload.bidStatus
      }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
        payload.perPage ?? 5
      }&HRMid=${payload?.hrmId}&jobId=${payload?.jobOrderId}&jobType=${
        payload?.jobType
      }`,
      { headers }
    );
  if (payload?.jobOrderId)
    return await axios.get(
      `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
        payload.bidStatus
      }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
        payload.perPage ?? 5
      }&jobId=${payload?.jobOrderId}&jobType=${payload?.jobType}`,
      { headers }
    );
  return await axios.get(
    `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
      payload.bidStatus
    }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${payload.perPage ?? 5}`,
    { headers }
  );
};

export const MessageAttachmentAPi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${sendAttachments}`, payload, { headers });
};

export const sendMessageAPI = async (
  conversationId,
  recipientId,
  message,
  formData
) => {
  const headers = await fetchToken();
  if (formData) {
    // const fileUploadResponse = await axios.request({
    //   url: sendAttachments,
    //   method: "post",
    //   processData: false,
    //   data: formData,
    // });
    const data = {
      ConversationId: conversationId,
      RecipientUserId: recipientId,
      MessageText: message,
      Attachments: formData,
    };
    return await axios.post(`${sendMessageUrl}`, data, { headers });
  } else {
    const data = {
      ConversationId: conversationId,
      RecipientUserId: recipientId,
      MessageText: message,
    };
    return await axios.post(`${sendMessageUrl}`, data, { headers });
  }
};

export const makeOfferAPi = async (params) => {
  const headers = await fetchToken();
  return await axios.post(
    `${offerAttachment}/${params.id.id}`,
    params?.data?.value ?? params?.data,
    {
      headers,
    }
  );
};

export const editOfferApi = async (params) => {
  const headers = await fetchToken();
  const results = await axios.put(
    `${editOfferUrl}/${params.id.id}`,
    params?.data?.value ?? params?.data,
    {
      headers,
    }
  );
  const HubSpotTrigger = {
    EventType: "Event_Bid_OnHired",
    GigID: results?.data?.GigId,
    ProfileID: results?.data?.ProfileId,
    SkillListingID: results?.data?.SkillListing?.SkillListingId,
    EmployerID: results?.data?.Gig?.ProfileId,
    Status: "Hired",
  };
  const HubSpotResults = axios.post(
    `${HubspotAPI}?id=${results?.data?.BidId}`,
    HubSpotTrigger,
    { headers }
  );
  return results;
};

export const createBidApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(createBidUrl, data, { headers });
};

export const createmultiBidApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(createmultiBidUrl, data, { headers });
};

export const updateBidApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.put(`${updateBidUrl}/${request.payload.id}`, data, {
    headers,
  });
};

export const retractBidApi = async (request) => {
  const headers = await fetchToken();
  return await axios.put(
    `${updateBidUrl}/${request.params.id}`,
    request.params,
    {
      headers,
    }
  );
};

//Interview
//Create interview API
export const createInterviewApi = async (request) => {
  const data = request.payload;
  const headers = await fetchToken();
  return await axios.post(
    `${createInterviewUrl}/${request.payload.bid_id}`,
    data,
    { headers }
  );
};

//Update interview API
export const updateInterviewApi = async (request) => {
  updateInterviewUrl = "";
  // const {InterviewStatus, DeclineReasonId, GigId,  Reason, ApprovedScheduledTiming, ScheduledTimings} = request.payload;
  const data = JSON.stringify(request.payload);
  if (
    request?.payload?.InterviewStatus == "Rescheduled" ||
    request.payload.reschedule
  ) {
    updateInterviewUrl = `${BackendApiBaseUrl}/interview/update`;
  } else if (request?.payload?.talent == true) {
    updateInterviewUrl = `${BackendApiBaseUrl}/interview/update`;
  } else {
    updateInterviewUrl = `${BackendApiBaseUrl}/interview/empupdate`;
  }
  const headers = await fetchToken();
  return await axios.put(
    `${updateInterviewUrl}/${request.payload.InterviewId}`,
    data,
    { headers }
  );
};
export const getProfileDetailAPi = async (id) => {
  // const headers=await fetchToken();
  const response = await axios.get(`${profileDetailsUrl}/${id}`, { headers });
  return response;
};

export const getProfileReviewsAPi = async (id) => {
  // const headers=await fetchToken();
  const response = await axios.get(`${profileDetailReviews}/${id}`, {
    headers,
  });
  return response;
};

// Update Profile Details
export const updatePersonalDetailsApi = async (params) => {
  const data = JSON.stringify(params);
  const headers = await fetchToken();
  return await axios.put(updatePersonalDetailsUrl, data, { headers });
};

export const getCompanyProfileDetailsApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getCompanyProfileDetailsUrl}`, {
    headers,
  });
  return response;
};

//get gigs in company profile

export const getCompanyGigsApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getCompanyGigsUrl}`, {
    headers,
  });
  return response;
};

//Get Personal Details Location
export const getPersonalDetailsLocationApi = async (location) => {
  const headers = await fetchToken();

  if (location == "") {
    return await axios.get(`${getPersonalDetailsLocationUrl}?location=`, {
      headers,
    });
  } else {
    return axios.get(`${getPersonalDetailsLocationUrl}?location=${location}`, {
      headers,
    });
  }
};

export const getFiltersAPi = async () => {
  return null
  return await axios.get(getFiltersUrl);
};

export const getKeywordSuggestionsApi = async (searchKey) => {
  const headers = await fetchToken();
  return await axios.get(`${getSearchSuggestionUrl}?${searchKey}`, { headers });
};

export const getSearchSuggestionsApi = async (params) => {
  const headers = await fetchToken();
  const type = params.obj.type.replace(/%20/g, " ");
  return await axios.get(
    `${getSearchSuggestionUrl}?search=${params.obj.search}&type=${type}`,
    { headers }
  );
};

export const getCompanyDetailsDropdownApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${getCompanyDetailsDropdownUrl}`, { headers });
};

export const postCompanyDetailsApi = async (data) => {
  const headers = await fetchToken();
  return await axios.put(postCompanyDetailsUrl, data, { headers });
};

export const fetchALLGigsApi = async (GigName) => {
  const headers = await fetchToken();
  return await axios.get(`${fetchAllGigsUrl}?gigName=${GigName}`, { headers });
};

export const getCulturePhotosApi = async (type) => {
  const headers = await fetchToken();
  return await axios.get(`${getCulturePhotosUrl}/${type.payload}`, { headers });
};

export const fetchViewsApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchViewsUrl}`, { headers });
};

export const addMessageToFavouriteApi = async (request) => {
  const headers = await fetchToken();
  return await axios.post(`${AddMessageToFavouriteUrl}`, request.payload, {
    headers,
  });
};

export const removeMessageFromFavouriteApi = async (request) => {
  const headers = await fetchToken();
  // 63903c5d930d3500082d6e21
  // ${request.payload.SourceId}
  return await axios.put(
    `${removeMessageFromFavouriteUrl}/${request.payload.SourceId}`,
    request.payload,
    { headers }
  );
};

export const fetchFollowersApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchFollowersUrl}`, { headers });
};

export const updateEmpProfileAlbumsApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.put(
    `${updateEmpProfileAlbumsUrl}/${request.payload.type}`,
    data,
    { headers }
  );
};

export const editEmpProfileAlbumsApi = async (request) => {
  // const data = JSON.stringify(request.payload.Picture);
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.put(
    `${eidtEmpProfileAlbumsUrl}/${request.payload.type}/${request.payload.id}`,
    data,
    { headers }
  );
};

export const deleteEmpProfileAlbumsApi = async (request) => {
  const data = JSON.stringify(request.payload.Picture);
  const headers = await fetchToken();
  return await axios.put(
    `${deleteEmpProfileAlbumsUrl}/${request.payload.type}`,
    data,
    { headers }
  );
};

export const getEmpProfileAlbumsApi = async (request) => {
  // const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.get(`${getEmpProfileAlbumsUrl}/${request.payload.type}`, {
    headers,
  });
};

//Post Gig Api
export const createGigApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(`${createGigUrl}`, data, { headers });
};
//Get gig title suggestions
export const getGigTitle = async (params) => {
  const headers = await fetchToken();
  return await axios.get(
    `${JobTitleUrl}?title=${params.title}&professionCode=${params.professionCode}`,
    { headers }
  );
};

export const getHRMDetails = async (params) => {
  console.log('params', params)
  try {
    const headers = await fetchToken();
    return await axios.get(
      `${getHRMDetailsAPI}`,
      // ?page=${params?.page || 1}&limit=${
      //   params?.limit || 10
      // }&search=${params?.search || undefined}&absAccountId=${
      //   params?.absAccountId || undefined
      // }`,
      { headers,params }
    );
  } catch (error) {}
};

export const getABSDetails = async (params) => {
  try {
    const headers = await fetchToken();
    return await axios.get(
      `${getABSDetailsAPI}`,
      { headers,params }
    );
  } catch (error) {}
};
//Get Skills Api
export const getSearchSkillsApi = async (params) => {
  const headers = await fetchToken();
  let query = params.payload.search;
  if (query.includes("#")) {
    params.payload.search.replace("#", "%23");
  }
  if (query.includes("+")) {
    params.payload.search.replace("+", ""); //will check in future
  }
  return await axios.get(
    `${getSearchSkillsUrl}/?skillName=${params.payload.search.replace(
      "#",
      "%23"
    )}&SkillCategoryId=${params.payload.id}`,
    { headers }
  );
};

//Update Gig Api
export const updateGigApi = async (request) => {
  // const {ExpiryDate, JobOrderStatusName} =request.payload;
  // let body= {ExpiryDate, JobOrderStatusName};
  let data = request.params;
  if (request?.params?.Location == null) {
    data = { ...request.params, Regions: null, Cities: null, Countries: null };
  }
  const headers = await fetchToken();
  return await axios.put(`${updateGigUrl}/${request.params.id}`, data, {
    headers,
  });
};
//update proposal api
export const updateProposalApi = async (request) => {
  const headers = await fetchToken();
  return await axios.put(
    `${updateProposalUrl}/${request.payload.id}`,
    request.payload,
    {
      headers,
    }
  );
};

//get user skill listing
export const getUserSkillListingApi = async (id) => {
  const headers = await fetchToken();
  return await axios.get(
    `${userSkillListing}?type=Published&userId=${id.payload}`,
    { headers }
  );
};

//skillListing Counts api

export const skillListingCountSagaApi = async (params) => {
  // const headers = await fetchToken();
  // const obj = params.params.obj
  //   ? { ...params.params.obj, CityId: [], RegionId: [], CountryId: [] }
  //   : params.params;
  // return await axios.put(`${SkillListingCount}`, { obj }, { headers });
  return null
};

// skill listing total count

export const skillListingTotalCountApi = async (params) => {
  // const headers = await fetchToken();

  // return await axios.put(`${SkillListingTotalCount}`, params.params, {
  //   headers,
  // });
  return null
};

//GET ALL JOBS
export const getJobListingApi = async (request) => {
  const headers = await fetchToken();
  if (request.payload.inputSearch) {
    return await axios.get(
      `${getJobListingUrl}/${request.payload.inputSearch}/${
        request.payload.currentPage
      }/${request.payload.pageSize}?sorttype=${
        request.payload.sorttype
      }&gigtype=${request.payload.gigType}&isPrivate=${
        request?.payload?.isPrivate ? request?.payload?.isPrivate : false
      }`,
      { headers }
    );
  } else if (request.payload.gigType) {
    return await axios.get(
      `${getJobListingUrl}/$/${request.payload.currentPage}/${
        request.payload.pageSize
      }?sorttype=${request.payload.sorttype}&gigtype=${
        request.payload.gigType
      }&isPrivate=${request.payload.sorttype}&gigtype=${
        request.payload.gigType
      }&isPrivate=${
        request?.payload?.isPrivate ? request?.payload?.isPrivate : false
      }`,
      { headers }
    );
  } else {
    return await axios.get(
      `${getJobListingUrl}/$/${request.payload.currentPage}/${
        request.payload.pageSize
      }?sorttype=${request.payload.sorttype}&isPrivate=${
        request.payload.sorttype
      }&gigtype=${request.payload.gigType}&isPrivate=${
        request?.payload?.isPrivate ? request?.payload?.isPrivate : false
      }`,
      { headers }
    );
  }
};

export const getJobListingResultApi = async (request) => {
  const headers = await fetchToken();
  if (request.payload.gigType) {
    return await axios.get(
      `${getJobListingUrl}/$/${request.payload.currentPage}/${request.payload.pageSize}?sorttype=${request.payload.sorttype}&gigtype=${request.payload.gigType}`,
      { headers }
    );
  }
};

export const getJobCountsApi = async (request) => {
  const headers = await fetchToken();

  try {
    return false
    const {
      countries,
      cities,
      regions,
      all,
      search,
      _sort = "MOST_RECENT",
      MygigsProfileId,
      explevel,
      Skills,
      JobOrderTypeName,
      isPrivateGig = false,
      JobOrderStatusName = "All",
    } = request?.payload?.body;

    return await axios.put(
      getJobCountsUrl,
      {
        obj: {
          countries: countries?.length ? countries : undefined,
          cities: cities?.length ? cities : undefined,
          regions: regions?.length ? regions : undefined,
          all: all || search || "",
          _sort,
          MygigsProfileId,
          Skills: Skills?.length ? Skills : undefined,
          explevel: explevel || undefined,
          JobOrderTypeName: JobOrderTypeName || undefined,
          isPrivateGig,
          JobOrderStatusName,
        },
      },
      { headers }
    );
  } catch (error) {
    console.warn("Error : ", error);
  }
};
export const getCandidateCountsApi = async (request) => {
  // const headers = await fetchToken();

  try {
    // return await axios.put(getCandidateCountsUrl, request?.payload || {}, {
    //   headers,
    // });
    return null
  } catch (error) {
    console.warn("Error : ", error);
  }
};

export const getJobListingDraftApi = async (request) => {
  const headers = await fetchToken();
  if (request.payload.inputSearch) {
    return await axios.get(
      `${getJobListingDraftUrl}/${request.payload.inputSearch}/${request.payload.currentPage}/${request.payload.pageSize}?sorttype=${request.payload.sorttype}`,
      { headers }
    );
  } else {
    return await axios.get(
      `${getJobListingDraftUrl}/$/${request.payload.currentPage}/${request.payload.pageSize}?sorttype=${request.payload.sorttype}`,
      { headers }
    );
  }
};

export const getRecentJobListingApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(`${getRecentJobListingUrl}/${request.payload}`, {
    headers,
  });
};

export const getPerUserSkillListingApi = async (id) => {
  const headers = await fetchToken();
  if (id.jobId) {
    return await axios.get(
      `${perUserSkillListing}/${id.skillId}?jobId=${id.jobId}`,
      { headers }
    );
  } else {
    return await axios.get(
      `${perUserSkillListing}/${id.skillId}?type=skillListing`,
      { headers }
    );
  }
};

export const deleteJobApi = async (request) => {
  const headers = await fetchToken();
  return await axios.delete(`${deleteJobUrl}/${request.payload.id}`, {
    headers,
  });
};

export const getjobTemplatesApi = async (params) => {
  // let data = JSON.stringify(type)

  const headers = await fetchToken();
  return await axios.get(
    `${fetchjobTemplateUrl}?type=${params.type}&JobOrderTypeName=${params.JobOrderTypeName}`,
    { headers }
  );
};

export const getJobDetailApi = async (JobOrderId) => {
  const headers = await fetchToken();
  return axios.get(`${getJobDetailUrl}/${JobOrderId}`, { headers });
};

export const getJobBidDetailApi = async (JobOrderId) => {
  const headers = await fetchToken();
  return axios.get(`${getJobBidDetailUrl}/${JobOrderId}`, { headers });
};

// SEARCHSUGGESTION
export const fetchSearchSuggestionsAPI = async (value) => {
  const headers = await fetchToken();
  const fetchSuggestionAPI = `${BackendApiBaseUrl}/search?search=${value.payload.obj.search}&type=${value.payload.obj.type}`;
  const response = await axios.get(fetchSuggestionAPI, { headers });
  return response;
};

export const getUserDashboardApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchdashboardUrl}`, { headers });
};

export const getUserDashboardInterviewApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchdashboardInterviewUrl}`, { headers });
};

export const getUserDashboardMatchesApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchdashboardMatchesUrl}`, { headers });
};

export const getGigRoleApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${BackendApiBaseUrl}/empgigs/getgigroles`, {
    headers,
  });
};

export const getRatingApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(`${getRatingUrl}/${request.id}?type=${request.type}`, {
    headers,
  });
};

//get Resume3d
export const getResume3dApi = async (id) => {
  const headers = await fetchToken();
  return await axios.get(`${getResume3dUrl}/${id}`, { headers });
};

//follow
export const followApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(`${followUrl}`, data, { headers });
};

//unfollow
export const unFollowApi = async (request) => {
  const data = JSON.stringify(request.payload.id);
  const headers = await fetchToken();

  return await axios.delete(`${unFollowUrl}/${request.payload.FollowerId}`, {
    headers,
  });
};

// get matched skills
export const getMatchedSkillsApi = async (gigid) => {
  const headers = await fetchToken();
  return await axios.get(`${getMatchedSkillsUrl}/${gigid}`, { headers });
};

export const getAllInterviewsApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${getAllInterviewsUrl}`, { headers });
};

// add to favourites
export const postFavoritesApi = async (SourceId) => {
  // let data = JSON.stringify(params);
  const headers = await fetchToken();
  return await axios.post(`${postFavoriteUrl}`, { SourceId }, { headers });
};

// delete from favourites
export const deleteFavoritesApi = async (SourceId) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${deleteFavoriteUrl}/${SourceId}`,
    {},
    {
      headers,
    }
  );

  return response;
};

// get favourites
export const getUserFavoritesApi = async (currentPage, pageSize, type) => {
  const headers = await fetchToken();
  return await axios.get(
    // `${fetchFavoritesUrl}/favorites/get?type=mobile=${currentPage}&perPage=${pageSize}`,
    // const fetchFavoritesUrl = `${BackendApiBaseUrl}/empprofile/favorites/get?type=web&page=1&perPage=`;
    `${fetchFavoritesUrl}?type=${type}&page=${currentPage}&perPage=${pageSize}`,
    { headers }
  );
};

export const addToMatchesApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${addToMatchUrl}`, payload, { headers });
};
export const addSingleMatchesApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${addToMatchUrl}`, payload, { headers });
};
export const addBatchMatchesApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${batchMatchUrl}`, payload, { headers });
};


export const removeFromMatchesApi = async (params) => {
  const headers = await fetchToken();
  return await axios.delete(
    `${removeFromMatchUrl}/${params.SkillListingId}/${params.GigId}`,
    { headers }
  );
};

export const getTimeSheetListApi = async (startdate, enddate) => {
  const headers = await fetchToken();
  return await axios.get(`${getTimeSheetListUrl}/${startdate}/${enddate}`, {
    headers,
  });
};

// export const approveTimesheetApi = async (Id) => {
//   const headers = await fetchToken();
//   const response = await axios.put(`${approveTimesheetUrl}/${Id}`, { headers });

// };

export const ApproveTimesheetAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.post(
    `${approveTimesheetUrl}/${params.id}/${params.start}/${params.end}`,
    {},
    { headers }
  );
};

export const RejectTimesheetAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.post(`${rejectTimesheetUrl}`, params, { headers });
};

export const getNotificationApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(
    `${notificationUrl}/?page=${
      request.payload?.currentPage ? request.payload.currentPage : 1
    }&perPage=${request?.payload?.getAll ? request?.payload?.pageSize : 10}`,
    { headers }
  );
};

export const getReadNotificationApi = async (NOTIFICATION_ID) => {
  const headers = await fetchToken();
  return await axios.put(
    `${readNotificationUrl}/${NOTIFICATION_ID}`,
    {},
    { headers }
  );
};

export const getTimesheetApi = async (userAssignmentId, startdate, enddate) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getTimesheetUrl}/${userAssignmentId}/${startdate}/${enddate}`,
    { headers }
  );
};

export const getPendingTeamMembersApi = async ({payload}) => {
  const {page=1,limit=10} = payload
  const headers = await fetchToken();
  return await axios.get(`${getPendingTeamMembersUrl}?page=${page}&limit=${limit}`, { headers });
};

export const getActiveTeamMembersApi = async ({payload}) => {
  const {page=1,limit=10} = payload
  const headers = await fetchToken();
  return await axios.get(`${getActiveTeamMembersUrl}?pageNumber=${page}&pageSize=${limit}`, { headers });
};

export const getInActiveTeamMembersApi = async ({payload}) => {
  const {page=1,limit=10} = payload
  const headers = await fetchToken();
  return await axios.get(`${getInActiveTeamMembersUrl}?pageNumber=${page}&pageSize=${limit}`, { headers });
};

export const addTeamMembersApi = async (params) => {
  const headers = await fetchToken();
  return await axios.post(`${addTeamMembersUrl}`, params, { headers });
};

export const updateTeamMembersApi = async (inv_id, params) => {
  const headers = await fetchToken();
  return await axios.put(`${updateTeamMembersUrl}/${inv_id}`, params, {
    headers,
  });
};

export const reactivateTeamMemberApi = async (member_id) => {
  const headers = await fetchToken();
  return await axios.put(
    `${reactivateTeamMemberUrl}/${member_id}`,
    {},
    { headers }
  );
};

//My Matches Api
export const getMatchesApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getMatchesUrl}/${request.payload.currentPage}/${request.payload.pageSize}/?sorttype=${request.payload.sorttype}`,
    { headers }
  );
};

// My matches sort
export const getMatchesSortApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getMyMatchesUrl}/1/12/?sorttype=${request.payload.sorttype}`,
    { headers }
  );
};

export const getGraphDetailsApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getGraphDetailsUrl}/${payload.userAssignmentId}/${payload.type}/${payload.startdate}/${payload.enddate}`,
    { headers }
  );
};

//get all payments
export const getAllPaymentsApi = async (payload) => {
  const headers = await fetchToken();
  return axios.get(
    `${getAllPaymentsUrl}/${payload.type}/${payload.start}/${payload.end}`,
    { headers }
    // `${getAllPaymentsUrl}/${payload.type}/null/null`,{ headers }
  );
};

// get candidates
export const getCandidatesApi = async (params) => {
  const headers = await fetchToken();
    return axios.get(
      `${candidatesUrl}/${params.payload?.bid_type_name}/${
        params?.payload?.bid_status_name
      }?startDate=${params.payload.startdate}&endDate=${
        params.payload.enddate
      }&page=${params.payload.page}&perPage=${params.payload.perPage}${isNull(params?.payload?.ABSId)?"":`&ABSId=${params?.payload?.ABSId}`}${isNull(params?.payload?.id)?"":`&id=${params?.payload?.id}`}&searchTerm=${params.payload.searchTerm || ""}${
        params?.payload?.bidType == "private" ? "&bidType=private" : ""
      }`, 
      { headers }
    );
 
};
// ABSId=${
//   params.payload.ABSId
// }
export const getCandidateCountApi = async (params) => {
  const headers = await fetchToken();
  // if (params.payload.HRMid) {
    return axios.get(
      `${getCandidateCountUrl}/${params.payload.bid_type_name}?${isNull(params?.payload?.ABSId)?"":`&ABSId=${params?.payload?.ABSId}`}${isNull(params?.payload?.id)?"":`&id=${params?.payload?.id}`}&startDate=${params.payload.startdate}&endDate=${
        params.payload.enddate
      }&searchTerm=${params.payload.searchTerm || ""}${
        params?.payload?.bidType == "private" ? "&bidType=private" : ""
      }`,
      { headers }
    );
  // } else {
  //   return axios.get(
  //     `${getCandidateCountUrl}/${params.payload.bid_type_name}?startDate=${
  //       params.payload.startdate
  //     }&endDate=${params.payload.enddate}
  //     &searchTerm=${params.payload.searchTerm || ""}${
  //       params?.payload?.bidType == "private" ? "&bidType=private" : ""
  //     }`,
  //     { headers }
  //   );
  // }
  // else if (
  //   params.payload.HRMid &&
  //   params.payload.HRMid == profile.AccountId
  // ) {
  //   return axios.get(
  //     `${getCandidateCountUrl}/${params.payload.bid_type_name}?startDate=${params.payload.startdate}&endDate=${params.payload.enddate}`,
  //     { headers }
  //   );
  // }
};

//Get recent Searches Api
export const getRecentSearchApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${recentSearchUrl}`, { headers });
  return response;
};

export const clearRecentSearchApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${clearRecentSearchUrl}`, { headers });
  return response;
};

export const getTrendingJobsApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${trendingJobsUrl}`, { headers });
  return response;
};

export const getMyMatches = async (request) => {
  const headers = await fetchToken();
  if (request.filters) {
    const response = await axios.get(
      `${findMyMatches}/${request.id}?hidePreviouslyViewed=${
        request?.filters?.hidePreviouslyViewed ?? false
      }${
        request?.filters?.Latitude
          ? "&Latitude=" + request?.filters?.Latitude
          : ""
      }${
        request?.filters?.Longitude
          ? "&Longitude=" + request?.filters?.Longitude
          : ""
      }${
        request.filters.skillListingType
          ? "&skillListingType=" + request?.filters?.skillListingType
          : ""
      }${
        request.filters.budgetType
          ? "&budgetType=" + request.filters.budgetType
          : ""
      }${
        request.filters.budgetMax
          ? "&budgetMax=" + request.filters.budgetMax
          : ""
      }${
        request.filters.budgetMin
          ? "&budgetMin=" + request.filters.budgetMin
          : ""
      }${request.filters.CityId ? "&CityId=" + request.filters.CityId : ""}${
        request.filters.RegionId ? "&RegionId=" + request.filters.RegionId : ""
      }${
        request.filters.experienceLevel
          ? "&experienceLevel=" + request.filters.experienceLevel
          : ""
      }${
        request.filters.sortType ? "&sortType=" + request.filters.sortType : ""
      }`,
      { headers }
    );
    return response;
  } else {
    const response = await axios.get(`${findMyMatches}/${request.id}`, {
      headers,
    });
    return response;
  }
};

export const getMatchesCountAPI = async (req) => {
  const headers = await fetchToken();
  const response = await axios.get(
    `${matchesCount}/${req.id}${req.filters ? req.filters : ""}`,
    { headers }
  );
  return response;
};

export const getMatchesPaginationAPI = async (req) => {
  const headers = await fetchToken();
  const response = await axios.get(
    `${matchesPagination}/${req.skip}/${req.limit}?hidePreviouslyViewed=${
      req.hideMatches ?? false
    }&sortType=${req?.matchesFilter}&skills=${req.HEADING}${
      req.filters?.length > 0 ? req.filters.replace("?", "&") : ""
    }`,
    { headers }
  );
  return response;
};

export const getMyABSAPI = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getABSurl}`, { headers });
  return response;
};

export const getMsgsCountApi = async (params) => {
  const headers = await fetchToken();
  // if (params?.jobId) {
  //   return await axios.get(
  //     `${messagesCountUrl}/${params?.allBids}?type=emp&jobId=${params?.jobId}&jobType=${params.jobType}`,
  //     { headers }
  //   );
  // }
  // if (params.hrmId)
  //   return await axios.get(
  //     `${messagesCountUrl}/${
  //       params?.bidTypeRadioValue ?? "all_bids"
  //     }?type=emp&HRMid=${params?.hrmId ?? null}`,
  //     { headers }
  //   );

  // return await axios.get(
  //   `${messagesCountUrl}/${
  //     params?.bidTypeRadioValue ?? params ?? "all_bids"
  //   }?type=emp`,
  //   { headers }
  // );
};

export const postNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.post(`${postNotesApiUrl}`, params, { headers });

  return response;
};

export const updateNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${updateNotesApiUrl}/${params.noteId}`,
    params,
    { headers }
  );

  return response;
};

export const getNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${getNotesApiUrl}/${params?.id}`, {
    headers,
  });

  return response;
};

export const getRemindersApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getRemindersUrl}`, { headers });
  return response;
};

export const getConversationIDApi = async (bidid) => {
  const headers = await fetchToken();
  const response = await axios.get(`${getCoversationIdURL}/${bidid}`, {
    headers,
  });
  return response;
};

// email verification API
export const sendEmailVerificationStatusAPI = async (params) => {
  const headers = await fetchToken();

  const response = await axios.post(`${sendEmailVerifyStatusURL}`, params, {
    headers,
  });
  return response;
};

export const addUpdateUserDeviceDeatils = async (data) => {
  const headers = await fetchToken();
  await axios.put(`${addUpdateUserDeviceDeatilsURL}`, data, { headers });
};

// My Gigs Filters

export const getMyGigFilters = async (value) => {
  return false
  const headers = await fetchToken();
  const {
    countries,
    cities,
    regions,
    all,
    _sort = "MOST_RECENT",
    MygigsProfileId,
    explevel,
    Skills,
    JobOrderTypeName,
    isPrivateGig = false,
    JobOrderStatusName = "All",
  } = value?.payload?.body;
  return await axios.put(
    getMyGigFiltersUrl,
    {
      obj: {
        countries: countries?.length ? countries : undefined,
        cities: cities?.length ? cities : undefined,
        regions: regions?.length ? regions : undefined,
        all: all || "",
        _sort,
        MygigsProfileId,
        Skills: Skills?.length ? Skills : undefined,
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        isPrivateGig,
        JobOrderStatusName,
      },
    },
    { headers }
  );
};

export const searchMyGigsLocationSuggestionsApi = async (value) => {
  let fetchLocationAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined || value.payload.value == "") {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getGigsLocation`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getGigsLocation?${value.payload.value}`;
  }

  const {
    countries,
    cities,
    regions,
    all,
    skills,
    _sort = "MOST_RECENT",
    MygigsProfileId,
    explevel,
    Skills,
    JobOrderTypeName,
    isPrivateGig = false,
    JobOrderStatusName = "All",
  } = value?.payload?.body;
  const response = await axios.put(
    fetchLocationAPI,
    {
      obj: {
        countries: countries?.length ? countries : undefined,
        cities: cities?.length ? cities : undefined,
        regions: regions?.length ? regions : undefined,
        all: all || "",
        MygigsProfileId,
        _sort,
        Skills: Skills?.length ? Skills : undefined,
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        isPrivateGig,
        JobOrderStatusName,
      },
    },
    {
      headers,
    }
  );
  return response;
};

export const searchMyGigsSkillsApi = async (value) => {
  let fetchSkillsAPI;

  const headers = await fetchToken();
  if (value.payload.value == undefined || value.payload.value == "") {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getGigsSkills`;
  } else {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getGigsSkills?${value.payload.value}`;
  }
  const {
    countries,
    cities,
    regions,
    all,
    skills,
    _sort = "MOST_RECENT",
    MygigsProfileId,
    explevel,
    Skills,
    JobOrderTypeName,
    isPrivateGig = false,
    JobOrderStatusName = "All",
  } = value?.payload?.body;
  const response = await axios.put(
    fetchSkillsAPI,
    {
      obj: {
        countries: countries?.length ? countries : undefined,
        cities: cities?.length ? cities : undefined,
        regions: regions?.length ? regions : undefined,
        all: all || "",
        _sort,
        MygigsProfileId,
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        isPrivateGig,
        JobOrderStatusName,
      },
    },
    {
      headers,
    }
  );
  return response;
};

export const removePrivateTalentAPI = async (payload) => {
  const headers = await fetchToken();
  const response = await axios.put(`${removePrivateTalent}/${payload}`, "", {
    headers,
  });
  return response;
};

export const userTrackingClickAPI = async (request) => {
  await axios.post(UserTrackingURL, request?.payload);
};

export const fetchCandidateSkillsApi = async (request) => {
  const categoryId = request.payload.profCode === "HC" ? 3 : 1;
  const response = await axios.get(
    `${getSkillsUrl}?skillName=${
      request.payload.val ? request.payload.val : request.payload
    }&SkillCategoryId=${categoryId}`
  );
  return response;
};

export const candidateEmailExistApi = async (payload) => {
  const headers = await fetchToken();
  try {
    const response = await axios.post(
      `${checkEmailExistURL}`, 
      { email: payload }, 
      { headers }
    );
    return response?.data; 

  } catch (error) {
    return  error.response.data ;
  }
};

export const addCandidateProfileApi = async (payload) => {
  const headers = await fetchToken();
  try {
    const response = await axios.post(
      `${profileAddCandidateURL}`, 
       payload , 
      { headers }
    );
    return response; 

  } catch (error) {
    console.warn(error)
    return error
  }
};

export const getInvitedTalentApi = async (request) => {
  const headers = await fetchToken();
 try {
  const response =  await axios.get(
    `${invitedTalentURL}/?searchTerm=${request.query? request.query: ""}&page=${
      request?.page ? request?.page : 1
    }&limit=${request?.limit ? request?.limit : 24}`,
    { headers }
  );
  return response;
 } catch (error) {
    console.log('error', error)
 }
};

export const checkIsUniqueNumber = async (number = "") => {
  try {
    const headers = await fetchToken();
    const response = await axios.post(
      numberCheckURL,
      { mobileNumber: number },
      {
        headers,
      }
    );
    return response.data.data.isNotExists;
  } catch (error) {
    return false
  }
};

export const checkGapAPI = async (request) => {
  const headers = await fetchToken();
 try {
  const response =  await axios.get(
    `${checkGapURL}/?BidId=${request.BidId}&BidType=${request.BidType}`,
    { headers }
  );
  return response;
 } catch (error) {
    console.log('error', error)
 }
};